/**
 * @generated SignedSource<<586bb2c7ed14daef853a76ffbd51f66f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tag"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "tag",
        "variableName": "tag"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "createTag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateTagMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateTagMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fe67c5b7adad6c373dc67b5cd8ae4109",
    "id": null,
    "metadata": {},
    "name": "CreateTagMutation",
    "operationKind": "mutation",
    "text": "mutation CreateTagMutation(\n  $tag: TagInput!\n) {\n  createTag(tag: $tag) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "b3d603bc20c7142e08976b2bd01c5d55";

export default node;
